<template>
  <div class="post-form-media-audio-item">
    <div class="thumbnail">
      <v-card-media
        v-if="media.poster && media.poster.inputPreview && !media.poster.removed"
        :src="media.poster.inputPreview"
        :style="{ width: '170px' }"
        :height="96"></v-card-media>
      <audio-default-thumbnail
        v-else-if="!media.poster || media.poster.removed"
        :width="170"
      ></audio-default-thumbnail>
      <audio-thumbnail v-else :media="media" :width="170"></audio-thumbnail>

      <div class="control">
        <template v-if="posterIsActive">
          <v-icon
            @click="removePoster"
            title="Видалити постер"
          >cancel</v-icon>
        </template>
        <template v-else>
          <div class="uploader" title="Завантажити постер">
            <v-icon>add_circle</v-icon>
            <input
              @change="onPosterAdded"
              type="file"
              accept="image/*"></input>
          </div>
        </template>

      </div>
    </div>

    <div class="media-content">
      <div class="media-title">
        <template v-if="media.audio.ref">
          <v-icon>audiotrack</v-icon> {{ media.audio.ref }}
        </template>
        <template v-else>
          <v-icon>audiotrack</v-icon>
          <v-icon title="Очікує завантаження на сервер">file_upload</v-icon>
          {{ media.audio.input.name }}
        </template>
      </div>

      <div class="media-comment-wrapper">
        <label>Коментар</label>
        <textarea-autosize
          v-model="media.audio.comment"


        ></textarea-autosize>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import { getImageFilePreview } from '@/services/ImagePreview';

import AudioThumbnail from '@/components/AudioThumbnail';
import AudioDefaultThumbnail from '@/components/AudioDefaultThumbnail';

export default {
  name: 'PostFormMediaAudioItem',
  components: {
    AudioThumbnail,
    AudioDefaultThumbnail,
  },
  props: {
    media: {
      type: Object,
      required: true,
    },
  },
  computed: {
    posterIsActive() {
      return this.media.poster &&
        (this.media.poster.input || (this.media.poster.ref && !this.media.poster.removed));
    },
  },
  methods: {
    onPosterAdded(event) {
      const file = event.target.files[0];

      if (file) {
        if (!this.media.poster) {
          Vue.set(this.media, 'poster', {});
        }
        Vue.set(this.media.poster, 'input', file);

        getImageFilePreview(file)
          .then((previewDataUri) => {
            Vue.set(this.media.poster, 'inputPreview', previewDataUri);
          });
      }
    },
    removePoster() {
      Vue.set(this.media.poster, 'removed', true);
    },
  },
};

</script>

<style scoped>

.post-form-media-audio-item {
  display: flex;
  flex-direction: row;
}

.thumbnail {
  /*display: flex;*/
  /*flex-direction: row;*/
  position: relative;
  margin-right: 10px;
}

.thumbnail .control {
  /*margin-left: -15px;*/
  /*margin-top: -15px;*/
  background: #fff;
  position: absolute;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  top: -14px;
  right: -14px;
}

.thumbnail .control .uploader {
  /*position: relative;*/
}

.thumbnail .control .uploader input {
  position: absolute;
  top: 0;
  bottom: 0;
  opacity: 0;
}

.media-content {
  flex: 1;
  margin-left: 10px;
}

.media-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.media-comment-wrapper label {
  font-size: 14px;
}

.media-comment-wrapper textarea {
  border: solid 1px #ddd;
  padding: 5px;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/PostFormMediaAudioItem.vue